<template>
  <v-card
    class="ma-0 py-2 px-4 pt-4"
    style="background: #F5F5F5"
    outlined
    tile
  >
    <validation-observer ref="validator" v-slot="{ handleSubmit }">
      <h3 class="form-title">
        THANH TOÁN NHIỀU LẦN
      </h3>
      <span class="close-btn cursor-pointer" @click="close()">
        <v-icon color="#9e9e9e">
          mdi-close
        </v-icon>
      </span>

      <v-row>
        <v-col class="pt-8 pb-0 d-flex" cols="4">
          <span class="my-auto">
            <v-icon color="#000">
              mdi-circle-small
            </v-icon>
            SỐ TIỀN CÒN LẠI CẦN THANH TOÁN: {{ formatCurrency(totalMoneyBase) }}
          </span>
        </v-col>
        <v-col class="pt-8 pb-0" cols="8">
          <div style="background-color: #0075FF33;border-radius:4px;" class="px-3 py-1">
            <v-icon style="color:#0075FF">mdi-information-slab-circle-outline</v-icon>
            <span style="color:#555555;font-style: italic;" class="mx-1">Hoàn tất thanh toán đơn hàng sẽ tự động mở khóa toàn bộ hạn học, bao gồm hạn học gốc và cả ưu đãi, khuyến mại</span>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pt-2 pb-0" cols="5">
          <v-row>
            <v-col class="py-0 pt-2">
              <span>
                <v-icon color="#000">
                  mdi-circle-small
                </v-icon>
                SỐ TIỀN THANH TOÁN LẦN 1*: 
              </span>
            </v-col>
            <v-col class="py-0">
              <validation-provider
                v-if="!$route.query.record_type"
                v-slot="{ errors }"
                name="Số tiền thanh toán lần 1"
                :rules="{ min_value: 0, max_value: totalMoneyBase, required: true, numeric: true }"
              >
                <v-text-field
                  label=""
                  :error-messages="errors"
                  placeholder="Nhập số tiền thanh toán lần 1"
                  dense
                  type="number"
                  v-model="payPrice"
                ></v-text-field>
              </validation-provider>
              <div v-if="$route.query.record_type == 'transfer_product' || $route.query.record_type == RECORD_TYPE.UPSALE" class="string-form mt-1">
                {{formatCurrency(payPrice)}}
              </div>
            </v-col>
          </v-row>
        </v-col>
        <v-col class="pt-2 pb-0" cols="5">
          <v-row>
            <v-col cols="5" class="py-0 pt-2" style="padding-right:0px">
              <span>
                <v-icon color="#000">
                  mdi-circle-small
                </v-icon>
                Phương thức thanh toán
              </span>
            </v-col>
            <v-col class="py-0" style="padding-left: 0px;">
              <v-select
                :items="paymentTypes"
                item-value="id"
                item-text="name"
                :aLight="'right'"
                placeholder="Chọn "
                label=""
                dense
                outlined
                :disabled="$route.query.record_type == 'transfer_product' || $route.query.record_type === RECORD_TYPE.UPSALE"
                height="30"
                v-model="paymentType"
                class="customer-pay-select mx-3"
                :class="{ 'short-w': !$route.query.record_type }"
                :menu-props="{ top: true, offsetY: true, maxHeight: '200' }"
              ></v-select>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <div v-if="$route.query.record_type == 'transfer_product' && checkAuthorization('exchange-payment_read')" class="px-2 py-1 d-flex justify-end">
       <div style="width: max-content">
         <v-select
             :items="conversionList"
             item-value="id"
             item-text="name"
             :aLight="'right'"
             placeholder="Chọn "
             label=""
             dense
             style="width: 330px"
             outlined
             height="30"
             v-model="conversionType"
             :menu-props="{ top: true, offsetY: true, maxHeight: '300' }"
         >
           <template v-slot:selection="{ item }">
             {{ getTextActivated(item.id) }}
           </template>
           <template slot="item" slot-scope="data">
             <div style="padding: 8px">
               <span style="font-weight: 500;font-size:14px">{{ data.item.name }}</span>

               <div v-if="data.item && data.item.comment" class="text-muted">
                 <span style="font-style: italic;font-size:12px">{{ data.item.comment }}</span>
               </div>
             </div>
           </template>
         </v-select>
       </div>
      </div>
      <div v-if="$route.query.record_type == 'transfer_product'" class="px-4 py-2 d-flex justify-space-between" style="background-color: #DDDDDD;border-radius: 8px">
        <div style="color:#002E86">TỔNG TIỀN ĐÃ THANH TOÁN: <span>{{formatCurrencyNoD(0)}} đ</span></div>
        <div style="color:#AC0606">TỔNG TIỀN ĐÃ QUY ĐỔI: <span>{{formatCurrencyNoD(0)}} đ</span></div>
        <div style="color:#279600">TỔNG TIỀN CÓ THỂ QUY ĐỔI: <span>{{formatCurrencyNoD(moneyPay)}} đ</span></div>
      </div>
      <v-row>
        <v-col class="py-3" cols="12" :key="keyRender">
          <v-simple-table class="table-layout table-products-pay" id="style-2" fixed-header style="background: #f5f5f5;">
            <thead>
              <tr>
                <th class="col-program-name text-left" style="background: #f5f5f5;">Gói học thử</th>
                <th class="col-expired text-left" style="background: #f5f5f5;">Tên con</th>
                <th class="col-expired text-left" style="background: #f5f5f5;">Thời hạn</th>
                <th class="col-exchange text-left" style="width: 180px;background: #f5f5f5;">Thời hạn đã quy đổi</th>
                <th class="col-total-exchange text-left" style="width: 220px;background: #f5f5f5;">Nhập thời hạn muốn quy đổi</th>
                <th class="col-total-money text-left" style="width: 180px;background: #f5f5f5;">Thành tiền</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(item, index) in products" >
                <tr :key="'tr' + index" v-if="item.type !== 'combo'">
                  <td class="text-left">
                    {{ item.productName }}
                    <br>
                    <span v-if="item.isError" style="color: red">Không có gói 1 buổi tương ứng để quy đổi.</span>
                  </td>
                  <td class="text-left"> {{showChildName(item)}}</td>
                  <td class="text-left">
                    <div class="d-flex pb-2">
                      <div class="string-form">
                        <span v-if="item.type === 'tutor'">{{Number(item.package.split('-')[1]) * Number(item.count)}}</span>
                        <span v-if="item.type === 'duo'">{{item.duration}}</span>
                      </div>
                      <div class="mx-1">
                        {{
                          item.type === "tutor"
                            ? "(Buổi)"
                            : "(Tháng)"
                        }}
                      </div>
                    </div>
                  </td>
                  <td class="text-left">
                    <div class="d-flex pb-2">
                      <div class="string-form">
                        0
                      </div>
                      <div class="mx-1">
                        <span v-if="item.type === 'tutor'">(Buổi)</span>
                        <span v-if="item.type === 'duo'">(Tháng)</span>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div v-if="item.type === 'tutor'" class="d-flex" style="justify-content: left;">
                      <validation-provider
                        v-slot="{ errors }"
                        :name="`Thời hạn muốn quy đổi ${index + 1}`"
                        :rules="{ min_value: 0, max_value: parseInt(item.package.split('-')[1]* Number(item.count)), required: true, numeric: true }"
                      >
                        <v-text-field
                          label=""
                          :error-messages="errors"
                          placeholder="Nhập thời hạn muốn quy đổi"
                          dense
                          :disabled="!payPrice || item.isError"
                          type="number"
                          v-model="item.trailLessons"
                        ></v-text-field>
                      </validation-provider>
                      <v-tooltip right v-if="showWaring(item)">
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on" style="cursor: pointer;color:#FF7A00" class="mb-2">mdi-information-slab-circle</v-icon>
                          </template>
                          <span>Nhập {{item.package.split('-')[1]* Number(item.count)}} để hoàn thành quy đổi toàn bộ hạn học</span>
                      </v-tooltip>
                      <div class="pt-3 pl-2">
                        (Buổi)
                      </div>
                    </div>
                    <div v-if="item.type === 'duo'" class="d-flex" style="justify-content: left;">
                      <validation-provider
                        v-slot="{ errors }"
                        :name="`Thời hạn muốn quy đổi ${index + 1}`"
                        :rules="{ min_value: 0, max_value: parseInt(item.duration), required: true, numeric: true }"
                      >
                        <v-text-field
                          label=""
                          :error-messages="errors"
                          placeholder="Nhập thời hạn muốn quy đổi"
                          dense
                          :disabled="!payPrice || item.isError"
                          type="number"
                          v-model="item.trailLessons"
                        ></v-text-field>
                      </validation-provider>
                      <v-tooltip right v-if="showWaring(item)">
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on" style="cursor: pointer;color:#FF7A00" class="mb-2">mdi-information-slab-circle</v-icon>
                          </template>
                          <span>Nhập {{parseInt(item.duration)}} để hoàn thành quy đổi toàn bộ hạn học</span>
                      </v-tooltip>
                      <div class="pt-3 pl-2">
                        (Tháng)
                      </div>
                    </div>
                    
                  </td>
                  <td class="text-left">
                    <div class="d-flex pb-2">
                      <div class="string-form" :style="{color: showWaring(item) ? '#FF7A00' : ''}">
                        <span v-if="Number(item.trailLessons) == (item.type === 'tutor' ? parseInt(item.package.split('-')[1]* Number(item.count)) : parseInt(item.duration))" style="color: #0075FF"> 
                          {{formatCurrencyNoD(((item.price-item.discount)*Number(item.count)))}}
                        </span>
                        <span v-else>
<!--                          {{ item.baseOrgPrice ? formatCurrencyNoD((item.type == 'tutor' ? item.baseOrgPrice : Math.ceil(item.baseOrgPrice/item.duration*1.5)) * Number(item.trailLessons)) : '0' }}-->
                          {{item.trailLessons ?  formatCurrencyNoD(totalProduct(item)) : '' }}
                        </span>
                        <v-tooltip bottom v-if="showWaring(item)">
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on" style="cursor: pointer;color:#FF7A00" class="mb-1">mdi-alert-circle</v-icon>
                          </template>
                          <span>Số tiền quy đổi đã lớn hơn giá trị sản phẩm gốc. Hãy quy đổi toàn bộ hạn học để tối ưu chi phí.</span>
                        </v-tooltip>
                      </div>
                      <div class="mx-1">(đ)</div>
                    </div>
                  </td>
                </tr>
                <template v-if="item.type == 'combo'">
                  <tr :key="'combo'+index">
                    <td class="text-left">{{item.productName}}</td>
                    <td class="text-left"> {{showChildName(item)}}</td>
                    <td class="text-left">--</td>
                    <td class="text-left">--</td>
                    <td class="text-left">--</td>
                    <td class="text-left">
                      <div class="d-flex">
                        <div class="string-form"> 
                          <span v-if="totalComboByItem(item) == (item.price*item.count-item.discount)" style="color:#0075FF">
                            {{formatCurrencyNoD(totalComboByItem(item))}}
                          </span>
                          <span v-else :style="{color: (totalComboByItem(item) > (item.price*item.count-item.discount)) ? '#FF7A00' : '#555555'}">
                            {{formatCurrencyNoD(totalComboByItem(item))}}
                          </span>
                          <v-tooltip bottom v-if="totalComboByItem(item) > (item.price*item.count-item.discount)">
                            <template v-slot:activator="{ on }">
                              <v-icon v-on="on" style="cursor: pointer;color:#FF7A00" class="mb-1">mdi-alert-circle</v-icon>
                            </template>
                            <span>Số tiền quy đổi đã lớn hơn giá trị sản phẩm gốc. Hãy quy đổi toàn bộ hạn học để tối ưu chi phí.</span>
                          </v-tooltip>
                        </div> 
                        <span class="mx-1">(đ)</span>
                      </div>
                    </td>
                  </tr>
                  <tr v-for="duo in item.skuDuos" :key="'duoSku' + duo.name + index">
                    <td class="text-left">
                      <span class="pl-2">● <span class="mx-2">{{ duo.name }}</span></span>
                    </td>
                    <td class="text-left">--</td>
                    <td class="text-left">
                      <div class="d-flex pb-2">
                        <div class="string-form">
                          {{ duo.duration }}
                        </div>
                        <div class="mx-1">
                          (Tháng)
                        </div>
                      </div>
                    </td>
                    <td class="text-left">
                      <div class="d-flex">
                        <div class="string-form">0</div> 
                        <span>(Tháng)</span>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex" style="justify-content: left;">
                        <validation-provider
                          v-slot="{ errors }"
                          :name="`Thời hạn muốn quy đổi ${duo.name + index}`"
                          :rules="{ min_value: 0, max_value: parseInt(duo.duration), required: true, numeric: true }"
                        >
                          <v-text-field
                            label=""
                            :error-messages="errors"
                            placeholder="Nhập thời hạn muốn quy đổi"
                            dense
                            :disabled="!payPrice || duo.isError"
                            type="number"
                            v-model="duo.trailLessons"
                          ></v-text-field>
                        </validation-provider>
                        <div class="pt-3 pl-2">
                          (Tháng)
                        </div>
                      </div>
                    </td>
                    <td class="text-left">
                      <div class="d-flex pb-2">
                        <div class="string-form">
                          <span v-if="totalComboByItem(item) == (item.price*item.count-item.discount)">--</span>
                          <span v-else>{{ duo.orgPrice ? formatCurrencyNoD(Math.ceil(duo.orgPrice/duo.duration*1.5) * Number(duo.trailLessons)) : '0' }}</span>
                        </div>
                        <div class="mx-1">(đ)</div>
                      </div>
                    </td>
                  </tr>
                  <tr v-for="tutor in item.skuTutors" :key="'tutorSku' + tutor.name + index">
                    <td class="text-left">
                      <span class="pl-2">
                        ● <span class="mx-2">{{ tutor.name }}</span>
                        <br>
                        <span v-if="!tutor.skuTutorPaymentUnit" style="color: red">Không có gói 1 buổi tương ứng để quy đổi.</span>
                      </span>
                    </td>
                    <td class="text-left">--</td>
                    <td class="text-left">
                      <div class="d-flex pb-2">
                        <div class="string-form">
                          {{ Number(tutor.package.split('-')[1]) * Number(item.count) * Number(tutor.comboDetail && tutor.comboDetail.itemQuantity ? tutor.comboDetail.itemQuantity : 1) }}
                        </div>
                        <div class="mx-1">
                          (Buổi)
                        </div>
                      </div>
                    </td>
                    <td class="text-left">
                      <div class="d-flex">
                        <div class="string-form">0</div> 
                        <span>(Buổi)</span>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex" style="justify-content: left;">
                      <validation-provider
                        v-slot="{ errors }"
                        :name="`Thời hạn muốn quy đổi ${tutor.name + index}`"
                        :rules="{ min_value: 0, max_value: parseInt(tutor.package.split('-')[1]* Number(item.count)* Number(tutor.comboDetail && tutor.comboDetail.itemQuantity ? tutor.comboDetail.itemQuantity : 1)), required: true, numeric: true }"
                      >
                        <v-text-field
                          label=""
                          :error-messages="errors"
                          placeholder="Nhập thời hạn muốn quy đổi"
                          dense
                          :disabled="!payPrice || !tutor.skuTutorPaymentUnit"
                          type="number"
                          v-model="tutor.trailLessons"
                        ></v-text-field>
                      </validation-provider>
                      <div class="pt-3 pl-2">
                        (Buổi)
                      </div>
                    </div>
                    </td>
                    <td class="text-left">
                      <div class="d-flex pb-2">
                        <div class="string-form">
                          <span v-if="totalComboByItem(item) == (item.price*item.count-item.discount)">--</span>
                          <span v-else>{{ (tutor.orgPrice && tutor.skuTutorPaymentUnit) ? formatCurrencyNoD(tutor.skuTutorPaymentUnit.orgPrice * Number(tutor.trailLessons)) : '0' }}</span>
                        </div>
                        <div class="mx-1">(đ)</div>
                      </div>
                    </td>
                  </tr>
                </template>
              </template>
            </tbody>
          </v-simple-table>
        </v-col>
      </v-row>

      <v-row>
        <v-col class="py-3 justify-end d-flex pr-10" cols="12">
          <span class="mr-10">
            <v-icon color="#000">
              mdi-circle-small
            </v-icon>
            <strong>Tổng tiền quy đổi lần này: {{ totalMoney() ? formatCurrency(totalMoney()) : 0 }}</strong>
          </span>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="text-center">
          <v-btn
            class="btn-success"
            @click.prevent="handleSubmit(createOrder)"
            color="#35b707"
            height="38"
            width="100"
            :disabled="isDisableForm || isDisableCreate"
          >
            <span>Tiếp tục</span>
          </v-btn>

          <v-btn
            class="btn-cancel"
            color="#b70727"
            height="38"
            width="100"
            @click="close()"
          >
            Hủy
          </v-btn>
        </v-col>
      </v-row>
    </validation-observer>
  </v-card>
</template>
<script>
import RepositoryFactory from '@/repositories/RepositoryFactory';
import {v1 as uuidv1} from 'uuid'
import { showChildName_C, formatCurrencyNoD_C }  from "../HelperFunc";
import {RECORD_TYPE} from "../../../../helpers/constants";
const AddressRepository = RepositoryFactory.get('address');
const OrderRepository = RepositoryFactory.get('order');

export default {
  name: 'MultiStepPay1',
  data() {
    return {
      payPrice: null,
      paymentType: 'COD',
      paymentTypes: [
        {
          id: 'COD',
          name: 'COD',
        },
        {
          id: 'BANK',
          name: 'BANK',
        },
      ],
      conversionType: 1,
      conversionList: [
        { id: 1, name: 'Quy đổi giá lẻ 1 buổi' },
        { id: 2, name: 'Quy đổi giá trung bình CHƯA khuyến mại', comment: '( Chỉ áp dụng cho quy đổi sản phẩm lẻ gia sư )' },
        { id: 3, name: 'Quy đổi giá trung bình CÓ khuyến mại',  comment: '( Chỉ áp dụng cho quy đổi sản phẩm lẻ gia sư )' },
      ],
      listProductConversion: [],
      keyRender: 0,
      // productsClone: this.products.map((item) => {
      //   return {
      //     trailLessons: 0,
      //     ...item,
      //   }
      // }),
      isDisableForm: false,
    };
  },
  props: {
    listProvince: {
      type: Array,
      default: () => [],
    },
    products: {
      type: Array,
      default: () => [],
    },
    paymentPeriod: {
      type: Number,
      default: () => null,
    },
    // paymentType: {
    //   type: String,
    //   default: () => null,
    // },
    isNotTrail: {
      type: Boolean,
      default: () => false,
    },
    isTrail: {
      type: Boolean,
      default: () => false,
    },
    receiverName: {
      type: String,
      default: () => null,
    },
    phone: {
      type: String,
      default: () => null,
    },
    detailAddress: {
      type: String,
      default: () => null,
    },
    wardId: {
      type: Number,
      default: () => null,
    },
    districtId: {
      type: Number,
      default: () => null,
    },
    provinceId: {
      type: Number,
      default: () => null,
    },
    paymentPeriods: {
      type: Array,
      default: () => [],
    },
    childs: {
      type: Array,
      default: () => [],
    },
    stepMoney: {
      type: Number,
      default: () => 0,
    },
    contactId: {
      type: Number,
      default: () => null,
    },
    fillMoney: {
      type: Number,
      default: () => 0,
    },
    moneyPay: {
      type: Number,
      default: () => 0,
    },
  },
  computed: {
    isDisableCreate() {
      const paymentMethod = this.paymentTypes.find(item => item.id === this.paymentType);
      if(paymentMethod &&  paymentMethod.amountRemaining && this.payPrice &&  parseFloat(this.payPrice) > 0) {
        const totalReceipt = paymentMethod && paymentMethod.amountRemaining ? paymentMethod.amountRemaining : 0;
        return parseFloat(this.payPrice) > parseFloat(totalReceipt);
      }
      return false;
    },
    listProduct () {
      return this.products.map((item) => {
        return {
          ...item
        }
      })
    },
    RECORD_TYPE() {
      return RECORD_TYPE
    },
    totalMoneyBase() {
      return this.products.reduce((acc, current) => {
        return acc + (current.price * current.count - current.discount);
      }, 0);
    },
  },
  watch: {
    conversionType: {
      handler() {
        this.getProductPaymentUnit()
      },
      immediate: true
    },
    payPrice(val) {
      console.log(val, 'val')
      if (!val || val === '') {
        this.products.map(item => {
          item.trailLessons = null;
          if (item.type === 'combo') {
            item.skuDuos.map(duo => {
              duo.trailLessons = null;
            });
            item.skuTutors.map(tutor => {
              tutor.trailLessons = null;
            });
          }
        });
      }
    },
  },
  created() {
    if (this.products.length) {
      this.products.forEach((item) => {
        this.getBaseSku(item);
      })
    }
    if (this.fillMoney && this.$route.query.record_type == 'transfer_product') {
      this.payPrice = this.moneyPay;
      this.paymentTypes.push({
        id: 'MONEY_RECEIPT',
        name: 'Biên nhận',
      });
      this.paymentType = 'MONEY_RECEIPT';
    }else if (this.fillMoney && this.$route.query.record_type === RECORD_TYPE.UPSALE) {
      this.payPrice = this.moneyPay;
      this.paymentTypes.push({
        id: 'MONEY_RECEIPT',
        name: 'Biên nhận',
      });
      this.paymentType = 'MONEY_RECEIPT';
    }else {
      this.callApiPaymentMethod();
    }

  },
  methods: {
    async callApiPaymentMethod() {
      try{
        const response = await OrderRepository.getPaymentMethodApi(this.contactId);
        if(response.success) {
          const optionReceipt = this.paymentTypes.find(item => item.id == 'MONEY_RECEIPT');
          if(!optionReceipt && response.data.length > 0) {
            const newPaymentTypes = response.data.map(item => ({
              id: `MONEY_RECEIPT-${item.id}`,
              name: `Biên nhận${item.amountRemaining ? ' - ' + formatCurrencyNoD_C(item.amountRemaining) : ''}`,
              value: item.id,
              amountRemaining: item.amountRemaining ? item.amountRemaining : 0
            }));
            this.paymentTypes.push(...newPaymentTypes);
          }
        }
      }catch (e) {
        console.log(e)
      }
    },
    totalProduct (item) {
      if(item.idBlock) {
       const findProduct = this.listProductConversion.find(data => data.id === item.idBlock)
        if(findProduct) {
          return findProduct.paymentUnitAmount * Number(item.trailLessons)
        }
      }
      return 0

    },
    formatDataOrder() {
      let totalPrice = 0;
      if(this.listProduct) {
        return this.listProduct.map((item) => {
          totalPrice += ((item.price * item.count) - item.discount);
          if (totalPrice < 0) totalPrice = 0;
          const campaigns = item.campaigns.map((itemC) => {
            return {
              code: itemC.code,
              type: itemC.type,
              giftIndexes: itemC.giftIndex >= 0 ? [itemC.giftIndex] : [],
              promotionSubCode: itemC.raw.promotionSubCode ? itemC.raw.promotionSubCode : null,
            };
          });
          return {
            id: item.idBlock,
            orderType: item.isNew ? 1 : 2,
            productId: item.productId,
            productType: `sku_${item.type}`,
            quantity: item.count,
            customerId: item.customerId,
            activeType: item.activeType,
            price: item.price,
            intoMoney: ((item.price * item.count) - item.discount) > 0 ? ((item.price * item.count) - item.discount) : 0,
            campaigns,
          };
        });
      }
    },
    async getProductPaymentUnit() {
      try {
        const data = {
          trialExchangePriceType: this.conversionType,
          products: this.formatDataOrder()
        }
        const response = await OrderRepository.getProductPaymentUnitApi(data)
        if(response.success) {
          this.listProductConversion = response.data
        }else {
          this.listProductConversion = response.data
        }
      }catch (e) {
        console.log(e)
      }
    },
    getTextActivated(id) {
      if(id) {
        return this.conversionList.find(item => item.id === id).name
      }
      return  ''
    },
    showWaring(item) {
      if (Number(item.trailLessons) == (item.type === 'tutor' ? parseInt(item.package.split('-')[1]* Number(item.count)) : parseInt(item.duration))) return false;
      if ( this.totalProduct(item) >= ((item.price-item.discount)*Number(item.count))) return true;
      return false;
    },
    totalComboByItem(current) {
      let duosComplete = 0
      let tutorsComplete = 0
      let totalDuos = current.skuDuos.reduce((acc, item) => {
        if (Number(item.trailLessons) == parseInt(item.duration)) duosComplete += 1;
        return acc + (Math.ceil(item.orgPrice/item.duration*1.5) * Number(item.trailLessons));
      }, 0);
      let totalTutors = current.skuTutors.reduce((acc, item) => {
        if (Number(item.trailLessons) == parseInt(item.package.split('-')[1]* Number(current.count)*item.comboDetail.itemQuantity)) tutorsComplete += 1;
        return acc + ((item.skuTutorPaymentUnit ? item.skuTutorPaymentUnit.orgPrice : 0) * Number(item.trailLessons));
      }, 0);
      if (duosComplete == current.skuDuos.length && tutorsComplete == current.skuTutors.length) return (current.price*current.count-current.discount);
      return Number(totalDuos + totalTutors)
    },
    totalMoney() {
      let total = 0;
      this.products.forEach((current)=> {
        if (current.type == 'tutor') {
          total += Number(current.trailLessons) == (parseInt(current.package.split('-')[1]* Number(current.count))) ? ((current.price-current.discount)*Number(current.count)) : this.totalProduct(current);
        }
        if (current.type == 'duo') {
          total += Number(current.trailLessons) == parseInt(current.duration) ? (current.price-current.discount) : this.totalProduct(current);
        }
        if (current.type == 'combo') {
          total += this.totalComboByItem(current);
        }
      })
      return total;
    },
    async getBaseSku(product) {
      const params = {
        product_type: product.type,
        include_price_policy: 1,
        transaction_status: product.type == 'tutor' ? 'selling' : null,
        status: product.type == 'tutor' ? 'active' : null,
        num_of_lesson: product.type === 'tutor' ? 1 : null,
        product_id: product.type === 'tutor' ? product.productID : null,
        curriculum_id: product.curriculumId,
        teacher_type_ids: product.teacherType,
        class_type_ids: product.classTypeId,
        is_from_crm: 1,
        sku_ids: product.type == 'tutor' ?  null : [product.productId],
        include_sku_tutor_payment_unit: product.type == 'combo' ? 1 : null,
      };
      const res = await OrderRepository.advanceSearchForCombo(params);
      product.baseOrgPrice = 0;
      product.trailLessons = null;
      product.isError = false;
      if (res.data && !res.data.length) {
        product.isError = true;
        product.trailLessons = 0;
      }
			if (res && res.data && res.data.length) {
        product.baseOrgPrice = res.data[0].orgPrice;
        if (product.type === 'duo') {
          product.duration = res.data.find(item => item.id === product.productId).duration;
          if (product.priceType === 'custom') product.baseOrgPrice = Number(product.price);
        }
        if (product.type === 'combo') {
          product.skuDuos = res.data[0].skuDuos;
          product.skuDuos.map(item => {
            item.trailLessons = null;
          });
          product.skuTutors = res.data[0].skuTutors;
          product.skuTutors.map(item => {
            item.trailLessons = null;
            item.package = `${item.classTypeId}-${item.numOfLesson}`;
          });
        }
      }
      this.keyRender++;
    },
    createOrder() {
      if (this.totalMoneyBase == this.payPrice) {
        return this.$swal({
          type: 'error',
          title: 'Thông báo',
          text: 'Số tiền thanh toán bằng số tiền đơn hàng. Đề nghị chuyển sang hình thức thanh toán một lần.',
        });
      }
      let totalPrice = 0;
      totalPrice = this.totalMoney();
      if (totalPrice > this.payPrice) {
        return this.$swal({
          type: 'error',
          title: 'Thông báo',
          text: 'Tổng tiền quy đổi không được lớn số tiền thanh toán',
        });
      }
      this.$emit('createOrder', {
        payPrice: this.payPrice,
        paymentType: this.paymentType,
        products: this.products,
        trialExchangePriceType: this.conversionType,
        listProductConversion: this.listProductConversion
      });
    },
    close() {
      this.$emit('close');
    },
    showChildName(item) {
      return showChildName_C(this.childs, item);
    },
    formatCurrencyNoD(val) {
      return formatCurrencyNoD_C(val);
    },
  },

}
</script>

<style lang="scss" scoped>
.form-title {
  position: absolute;
}
.close-btn {
  position: relative;
  left: 98%;
}
.col-program-name {
  min-width: 120px;
  width: 290px;
}
.col-expired {
  min-width: 120px;
}
.col-exchange {
  min-width: 120px;
}
.col-total-exchange {
  min-width: 120px;
  width: 300px;
}
.col-total-money {
  min-width: 120px;
}
</style>
